// Note: This file gets updated by tool/update_version.js script as part of the Changesets release workflow.
// The update happens in the changesets PR, before the package is built.
export const POWERSYNC_JS_VERSION = '1.4.0';
//# sourceMappingURL=version.js.map